import { z } from "zod";
import { defineLens, listLens } from "../lens";
import { BULK_EVENT_LOG_LIMITS } from "../query";
import { defineEventLog } from "../spec";

/**
 * The feed-item event log: a workspace's readable, undeleted items, or some feeds' own, on their creation axis.
 *
 * Workspace-wide, what a cold client walks to hold the recent past of every feed at once; that read drives from a
 * fleet-wide index, so it is floored. With `feedIds` it reads those feeds alone, each from its own `(feedId,
 * createdAt)` index: a warmup batch in delta mode, or one feed's scroll-back in history mode, and needs no floor.
 * Every read serves the whole item, so the log has no shape parameters.
 */
export const feedItemsLog = defineEventLog({
  name: "feedItems",
  limits: BULK_EVENT_LOG_LIMITS,
  historyAxis: "createdAt",
  lenses: {
    feedIds: defineLens("feedIds", listLens(z.string().min(1)), {
      description:
        "Comma-separated ids of the feeds to read. Without it the read is workspace-wide, and needs a `since` at " +
        "most 14 days back.",
    }),
  },
  shape: {},
  floored: ({ feedIds }) => feedIds === undefined,
});
